var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-coupon-review',{ref:"table",staticClass:"pt-coupon-review__withData",on:{"pass":_vm.pass}})}
var staticRenderFns = []

export { render, staticRenderFns }